import { request, type DataInfoResponse, type PagedList } from './request';
import { buildListParams } from './params';
import type { AchievementDto } from './types';

export interface AchievementListOptions {
  pageIndex?: number;
  pageSize?: number;
  /** 成果标题搜索 */
  title?: string;
}

/** 成果转化列表（/achievement/userGetAchievementList，公开接口） */
export function fetchAchievementList(
  options: AchievementListOptions = {},
): Promise<PagedList<AchievementDto>> {
  const { pageIndex = 1, pageSize = 10, title = '' } = options;

  return request(
    '/achievement/userGetAchievementList',
    buildListParams({
      pageIndex,
      pageSize,
      state: 1,
      extra: { title },
    }),
  );
}

/** 成果转化详情（/achievement/userGetAchievementInfo，公开接口） */
export function fetchAchievementInfo(id: number): Promise<DataInfoResponse<AchievementDto>> {
  return request('/achievement/userGetAchievementInfo', { id });
}
